import React from "react";
import { Redirect } from 'react-router-dom';
import CheckoutUserForm from './../Forms/CheckoutUserForm.jsx';
import { Storage } from './../Core/Storage';
import { Routes } from './../Core/Constants';
import { UserProvider } from './../Providers/UserProvider';
import { Customer }  from './../Models/Customer';
import { Contact } from './../Models/Contact';

export default class EditUser extends React.Component {
	state = {
	}

	componentDidMount = () => {
		UserProvider.getUser((data) => {
			let customer = new Customer();
			window.gtm.loadAccount("edituser");
			customer.invoiceContact = data.invoiceContact;
			customer.deliveryContact = data.deliveryContact;
			if (!customer.invoiceContact) {
				customer.invoiceContact = new Contact();
				customer.invoiceContact.email = customer.username;
			}
			if (!customer.deliveryContact) {
				customer.deliveryContact = new Contact();
				customer.deliveryContact.isDeliveryContact = false;
			}
			this.setState({ customer: customer });
		});
	}

	handleSubmit = (values, setSubmitting) => {
		let model = {
			invoiceContact: values.invoiceContact,
			sendNews: values.sendNews,
			notes: values.remarks,
			deliveryContact: values.deliveryContact.isDeliveryContact ? values.deliveryContact:null
		};
	
		UserProvider.updateUser(model, (data) => {
			alert('Vaše údaje byly uloženy!')
			Storage.instance.customer = null;
			setSubmitting(false);
		},
			(err) => {
				///todo
				setSubmitting(false);
			});
	}

	render = () => {
		let T = window.Texts.checkout;
		if (!Storage.instance().isAuthorized()) {
			return (
				<Redirect to={Routes.Login} />);
		}
		let customer = this.state.customer;
		if (!customer)
			return null;

		return (
			<div className="edit-subject-page">
				<div className="headline">
					<h1>{T.editUserTitle}</h1>
				</div>
				<div className="inner-750">
					<CheckoutUserForm initValues={customer} onSubmit={(values, setSubmitting) => this.handleSubmit(values, setSubmitting)} />
				</div>
			</div>
		);
	}
}